import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { EnvironmentService } from '../../../../services/environment.service';
import { AdminService } from '../../../../services/admin.service';
import { MatTableDataSource } from '@angular/material/table';
import { OverlayService } from '../../../../services/overlay.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-garbage',
  templateUrl: './garbage.component.html',
  styleUrls: ['./garbage.component.scss']
})
export class GarbageComponent implements OnInit {
  encodingImageLink = `${this.environmentService.getUrl()}/static/admin/encoding.png`;
  files: File[] = [];
  @ViewChild('fileInput') fileInput: ElementRef;
  previewData = null;

  columnDefs = [
    {
      name: 'Straße',
      field: 'street'
    },
    {
      name: 'Type',
      field: 'type'
    },
    {
      name: 'Datum',
      field: 'date'
    }
  ];
  garbageColumns = this.columnDefs.map(item => item.field);

  constructor(
    private environmentService: EnvironmentService,
    private adminService: AdminService,
    private overlayService: OverlayService,
    private router: Router) { }

  ngOnInit() {
  }

  triggerInput() {
    const file = this.files[0];
    this.adminService.uploadGarbageFile(file)
      .subscribe({
        next: res => {
          this.previewData = new MatTableDataSource(res);
        },
        error: () => {
          this.overlayService.openSnackBar(`Fehler beim Hochladen der Daten. Möglicherweise enthält die Datei nicht die richtige Anzahl an Spalten oder es wurde das falsche Trennzeichen verwendet.`, 'error');
        }
      })
  }


  startImport() {
    this.overlayService.openDialog('Sind Sie sich sicher?', 'Sobald der Import gestartet wurde, kann die Operation nicht mehr angehalten oder rückgängig gemacht werden!', 'Import starten')
      .subscribe(result => {
        if (result) {
          this.adminService.startGarbageImport().subscribe({
            next: () => {
              this.overlayService.openSnackBar(`Daten erfolgreich importiert.`, 'success');
              this.files = [];
              this.previewData =null;
            },
            error: () => {
              this.overlayService.openSnackBar(`Fehler beim Ausführen des Import.`, 'error');
            }
          })
        }
      });
  }

  onSelect(event) {
    this.files = [];
    this.files.push(...event.addedFiles);
    this.triggerInput();
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  movebacktoOverview() {
    this.router.navigateByUrl('admin/businessuser')

  }
}
